<template>
    <div class="customer-state-indicator">
        <span class="customer-state label" v-for="(detailedStates, topState) in customerStates" :class="getLabelClass(topState)">
            <span v-if="!mini" class="parent-state-label">{{topState}}</span>
            <span class="child-state badge" :class="getBadgeClass(detailedState)" :title="getTip(topState, detailedState)" v-for="detailedState in detailedStates" v-html="getStateText(detailedState)"></span>
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            customerStates: {
                type: Object,
                required: true
            },
            mini: {
                type: Boolean,
                default: true
            }
        },
        name: 'CustomerStateIndicator',
        data () {
            return {
            }
        },
        computed: {

        },
        methods: {
            getLabelClass: function (topState) {
                let label = ''
                switch (topState) {
                    case 'Customer':
                        label += 'success'
                        break
                    case 'Opportunity':
                        label += 'primary'
                        break
                    default:
                        label += 'default'
                        break
                }

                return 'label-' + label + (this.mini ? ' mini ' : '')
            },
            getBadgeClass: function (detailedState) {
                let label = ''
                switch (detailedState) {
                    case 'New':
                    case 'Recycled':
                        label = 'success'
                        break
                    case 'Stale':
                    case 'Current':
                        label = 'warning'
                        break
                    case 'Limbo':
                    case 'Dropped':
                        label = 'danger'
                        break
                    case 'Lost':
                    default:
                        label = 'info'
                        break
                }

                return 'progress-bar-' + label
            },
            getTip: function (topState, detailedState) {
                return topState + ': ' + detailedState
            },
            getStateText: function (detailedState) {
                return this.mini ? '&nbsp;' : detailedState
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .customer-state-indicator {
        display:inline-block;
    }
</style>



// WEBPACK FOOTER //
// CustomerStateIndicator.vue?5054bd30